import React from "react";
import { motion as Motion } from "framer-motion";
import { Helmet } from "react-helmet-async";
import ContactHero from "./contact/ContactHero";
import ContactForm from "./contact/ContactForm";
import ContactInfo from "./contact/ContactInfo";
import { useContactForm } from "./contact/useContactForm";

const ContactPage = () => {
  const initialFormData = {
    name: "",
    email: "",
    phone: "",
    message: "",
  };

  const contactForm = useContactForm(initialFormData);

  const fadeUp = {
    initial: { opacity: 0, y: 20 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, amount: 0.12 },
    transition: { duration: 0.6, ease: "easeOut" },
  };

  return (
    <div className="flex flex-col pt-16 md:pt-20 bg-[#f5f5f5]">
      <Helmet>
        <title>Reflection Futbol Academy | Contact Us</title>
        <meta
          name="description"
          content="Get in touch with RFA. Visit us in Oklahoma City, call +1(405)-588-9793, or send us a message for football training inquiries."
        />
        <link
          rel="canonical"
          href="https://reflectionfutbolacademy.com/contact"
        />
      </Helmet>

      {/* 1. Page Hero */}
      <ContactHero />

      {/* 2. Main Contact Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto site-gutter">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-16">
            {/* Contact Form */}
            <Motion.div {...fadeUp}>
              <ContactForm {...contactForm} />
            </Motion.div>

            {/* Contact Info */}
            <Motion.div
              {...fadeUp}
              transition={{ ...fadeUp.transition, delay: 0.2 }}
            >
              <ContactInfo />
            </Motion.div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
